import * as React from 'react'
import ReactDropzone, { useDropzone } from 'react-dropzone'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import * as styles from './index.vanilla.css'

type IllustrationType = React.ComponentProps<typeof Icon.Large>['icon']

type DropzoneProps = React.ComponentProps<typeof ReactDropzone>

interface Props extends DropzoneProps {
  icon?: string
  iconName?: IllustrationType
  message: string
  lite?: boolean
  description?: string
  forceHoverStyle?: boolean
  onClick?: () => void
  error?: boolean
}

const DropzoneBox = ({
  onDrop,
  accept,
  icon,
  message,
  noClick,
  noDrag,
  disabled = false,
  multiple = true,
  lite = false,
  iconName,
  description,
  forceHoverStyle = false,
  onClick = () => null,
  error,
}: Props) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    noClick,
    noDrag,
    onDrop,
    accept,
    disabled,
    multiple,
  })

  const hasHover = !disabled || forceHoverStyle

  return (
    <div {...getRootProps()} style={{ outline: 'none' }}>
      <Box
        width="full"
        textAlign="center"
        justifyContent="center"
        paddingY="s24"
        paddingX="s32"
        gap="s12"
        extra={{ 'data-intercom-target': 'documents-dropzone-box' }}
        borderRadius={{ all: 'abs006' }}
        border={{
          all: {
            width: 's2',
            style: 'dashed',
            color: error ? 'radicalRed1000' : 'grey400',
          },
        }}
        className={`${hasHover && styles.hoverDropzone} ${isDragActive && styles.activeDropzone}`}
        onClick={onClick}
        {...(lite ? { flexDirection: 'row' } : {})}
      >
        <input {...getInputProps()} />
        {(!!icon || !!iconName) && (
          <Box flexGrow {...(lite ? {} : { justifyContent: 'center', alignItems: 'center' })}>
            {icon && <img src={icon} />}
            {iconName && <Icon.Large icon={iconName} />}
          </Box>
        )}
        {lite ? <Text size="200">{message}</Text> : <Text.Normal>{message}</Text.Normal>}
        {description && <Text size="100">{description}</Text>}
      </Box>
    </div>
  )
}

export default DropzoneBox
